<template>
    <div v-if="tags && tags.length" class="public-tags">
        <button
            v-for="tag in tags"
            :key="tag"
            type="button"
            class="public-tags__tag"
            @click.stop="$emit('select', tag)"
        >{{ tag }}</button>
    </div>
</template>

<script>
export default {
    name: 'PublicTagList',
    props: {
        tags: {
            type: Array,
            default: () => [],
        },
    },
};
</script>

<style scoped>
.public-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin: 12px 0;
}

.public-tags__tag {
    border: 0;
    border-radius: 12px;
    padding: 2px 13px;
    background: #AD2C21;
    color: #ffffff;
    font-size: 12px;
    line-height: 18px;
    cursor: pointer;
    transition: opacity 0.15s ease;
}

.public-tags__tag:hover,
.public-tags__tag:focus-visible {
    opacity: 0.8;
}
</style>
